import { Pagination } from '@/ui';
import styled from 'styled-components';

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  margin: 2rem;
`;

export const StyledPagination = styled(Pagination)`
  margin-inline: auto;
`;

export const StyledButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
`;
